import { createStore } from 'vuex';

import user from '@/vuex/user';
import entities from '@/vuex/entities';
import search from '@/vuex/search';
import reviews from '@/vuex/reviews';
import savedItems from '@/vuex/saved-items';
import notifications from '@/vuex/notifications';

const store = createStore({
  strict: process.env.NODE_ENV !== 'production',

  modules: {
    user,
    entities,
    savedItems,
    search,
    reviews,
    notifications,
  },

  state: {
    ui: {
      loadingState: false,
    },
  },

  mutations: {
    setLoadingState(state, { loadingState }) {
      state.ui.loadingState = loadingState;
    },
  },

  getters: {
    getLoadingState(state) {
      return state.ui.loadingState;
    },
  },
});

export default store;
